import { HexMark, SquareMark, Wordmark, HexLockup, BrandColors } from '../../components/FieldCertLogo';
import { Category, Section, Row } from './galleryPrimitives';

/** Dark / light preview plate so logo variants read against the right surface. */
function Plate({ light = false, children }) {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '1rem',
        flexWrap: 'wrap',
        padding: '1rem 1.25rem',
        borderRadius: 'var(--radius-md, 8px)',
        background: light ? '#f7f4ee' : BrandColors.surface, // check-rules:ignore — brand canon surface for logo preview
        border: `1px solid ${light ? 'rgba(0,0,0,0.08)' : BrandColors.border}`,
      }}
    >
      {children}
    </div>
  );
}

/**
 * Brand — FieldCert logo marks (HexMark, SquareMark, Wordmark, HexLockup).
 * Source: components/FieldCertLogo.jsx
 *
 * `surface` drives the treatment: "auto" (default) follows the active data-theme,
 * "dark"/"light" force a fixed surface. The `light` boolean is deprecated — prefer `surface`.
 */
export default function BrandGallery() {
  return (
    <Category id="brand" title="Brand & logos">
      <Section name="HexMark" file="components/FieldCertLogo.jsx">
        <Row label='surface="auto" (follows theme toggle)'>
          <HexMark size={28} />
          <HexMark size={38} />
          <HexMark size={56} />
        </Row>
        <Row label='surface="dark"'>
          <Plate>
            <HexMark size={28} surface="dark" />
            <HexMark size={38} surface="dark" />
            <HexMark size={56} surface="dark" />
          </Plate>
        </Row>
        <Row label='surface="light"'>
          <Plate light>
            <HexMark size={28} surface="light" />
            <HexMark size={38} surface="light" />
            <HexMark size={56} surface="light" />
          </Plate>
        </Row>
      </Section>

      <Section name="Wordmark" file="components/FieldCertLogo.jsx">
        <Row label='surface="auto"'>
          <Wordmark size="sm" />
          <Wordmark size="md" />
        </Row>
        <Row label='surface="dark"'>
          <Plate>
            <Wordmark size="sm" surface="dark" />
            <Wordmark size="md" surface="dark" />
          </Plate>
        </Row>
        <Row label='surface="light"'>
          <Plate light>
            <Wordmark size="sm" surface="light" />
            <Wordmark size="md" surface="light" />
          </Plate>
        </Row>
      </Section>

      <Section name="HexLockup" file="components/FieldCertLogo.jsx">
        <Row label='surface="auto" (nav / sign-in)'>
          <HexLockup iconSize={38} wmSize="sm" />
        </Row>
        <Row label='surface="dark"'>
          <Plate>
            <HexLockup iconSize={38} wmSize="sm" surface="dark" />
          </Plate>
        </Row>
        <Row label='surface="light"'>
          <Plate light>
            <HexLockup iconSize={38} wmSize="sm" surface="light" />
          </Plate>
        </Row>
      </Section>

      <Section name="SquareMark (app icon / favicon)" file="components/FieldCertLogo.jsx">
        <Row label="app icon sizes">
          <Plate>
            <SquareMark size={28} />
            <SquareMark size={38} />
            <SquareMark size={56} />
            <SquareMark size={72} />
          </Plate>
        </Row>
      </Section>
    </Category>
  );
}
